exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-main-js": () => import("./../../../src/templates/main.js" /* webpackChunkName: "component---src-templates-main-js" */)
}

